import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import SearchPage from './pages/SearchPage'
import AudioWidget from './components/SpotifyWidget'
import { PodcastProvider, usePodcastContext } from './contexts/PodcastContext'

// Composant principal qui utilise le contexte
function AppContent() {
  const { currentTrack, isAudioWidgetExpanded, loading, error } = usePodcastContext()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-color to-secondary-color">
        <div className="text-center">
          <div className="loading mb-4"></div>
          <h2 className="text-white text-xl font-semibold mb-2">Podcast Search</h2>
          <p className="text-white/80">Chargement des épisodes du Floodcast...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-color to-secondary-color p-4">
        <div className="card text-center max-w-md w-full">
          <div className="text-red-500 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-red-600 mb-3">Erreur de chargement</h2>
          <p className="text-text-secondary mb-4">{error}</p>
          <div className="space-y-2">
            <button 
              className="btn btn-primary w-full" 
              onClick={() => window.location.reload()}
            >
              Réessayer
            </button>
            <p className="text-xs text-text-light">
              Si le problème persiste, vérifiez que les fichiers de données sont présents.
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="app min-h-screen flex flex-col bg-gradient-to-br from-primary-color to-secondary-color">
      <Header />
      
      <main 
        className={`flex-1 transition-all duration-300 ${
          currentTrack 
            ? (isAudioWidgetExpanded ? 'pb-70' : 'pb-35') 
            : 'pb-8'
        }`}
      >
        <Routes>
          <Route path="/" element={<SearchPage />} />
          <Route path="*" element={
            <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-8 text-center">
              <div className="card max-w-md mx-auto">
                <h2 className="text-xl font-semibold mb-2">Page non trouvée</h2>
                <p className="text-text-secondary mb-4">La page que vous cherchez n'existe pas.</p>
                <a href="/" className="btn btn-primary">
                  Retour à l'accueil
                </a>
              </div>
            </div>
          } />
        </Routes>
      </main>
      
      <AudioWidget />
    </div>
  )
}

function App() {
  return (
    <PodcastProvider>
      <AppContent />
    </PodcastProvider>
  )
}

export default App 